import styled, {css} from 'styled-components';

/*
 * Constants.
 */

const COLUMNS_COUNT = 12;

/*
 * Styles.
 */

export const ReportGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${COLUMNS_COUNT}, 1fr);
  column-gap: 48px;
  row-gap: 48px;
  grid-auto-rows: minmax(min-content, max-content);
`;

export const ReportGridItem = styled.div<{$width?: number; $hasFullHeight?: boolean}>`
  grid-column: span ${(p) => p.$width || COLUMNS_COUNT};
  ${(p) =>
    p.$hasFullHeight &&
    css`
      height: 100%;
    `}
  /* 
  Without this, the grid item children on firefox take more space than they are allowed.
  Fixes the Table not overflowing and the Donut going wild bugs. https://github.com/frontapp/front-client/pull/5462
  */
  max-width: 100%;
`;
